import {Injectable} from "@angular/core";
import {select, Store} from "@ngrx/store";
import {selectIsNodeDataChanged} from "@ispm-client/modules/bpmn-modeler/store/selectors/node-configuration-panel.selector";
import {map, take} from "rxjs/operators";
import {ConfirmModalComponent} from "@ispm/layout/components/modals/confirm-modal/confirm-modal.component";
import {modalResponse} from "@ispm/layout/constants/modal-responses.enum";
import {
  ClearNodeConfigurationData,
  SetInitialNodeConfigurationData,
  SetUpdatedNodeConfigurationData
} from "@ispm-client/modules/bpmn-modeler/store/actions";
import {State} from "@ispm-client/modules/bpmn-modeler/store/state";
import {Observable, Subscription} from "rxjs";
import {DynamicModalLoaderService} from "@ispm/layout/services/dynamic-modal-loader.service";
import {unsavedChangesDlgConstants} from '@ispm-client/modules/bpmn-modeler/constants/stringConstants';
import {CommandStackAction} from "@ispm/shared/bpmn-io/commandstack-action";
import {unsavedUserInitiatedActions} from "@ispm-client/modules/bpmn-modeler/store/selectors";

@Injectable()
export class NodePanelConfigurationService {

  protected modalSubscriber$: Subscription;
  protected unsavedChanges$: Observable<CommandStackAction[]>;
  private panelOpened: boolean = false;
  protected currentTab;

  constructor(protected modalLoader: DynamicModalLoaderService,
              private store$: Store<State>) {
    const currentApplication = sessionStorage.getItem('currentApplication');
    this.currentTab = currentApplication ? JSON.parse(currentApplication).items[0].identify : null;
  }

  set panelState(flag: boolean) {
    this.panelOpened = flag;
  }

  get panelState() : boolean {
    return this.panelOpened;
  }

  isNodeContentChanged(evtType: string, self: any, declineCallback, declineParam?: any, approveCallback?, approveParam?: any) {
    this.store$.pipe(
      select(selectIsNodeDataChanged),
      take(1))
      .subscribe(isNodeModified => {
        if (isNodeModified) {
          this.modalSubscriber$ = this.modalLoader.popupModal(ConfirmModalComponent,
            {
              title: unsavedChangesDlgConstants.TITLE,
              content: unsavedChangesDlgConstants.CONTENT,
              approveBtn: unsavedChangesDlgConstants.APPROVE_BTN,
              declineBtn: unsavedChangesDlgConstants.DECLINE_BTN
            })
            .filter(response => response.payload)
            .map(response => response.payload)
            .subscribe((response: modalResponse) => {
                switch (response) {
                  case modalResponse.decline:
                    declineCallback.call(self, declineParam);
                    this.store$.dispatch(new ClearNodeConfigurationData());
                    break;
                  case modalResponse.approve:
                  default:
                    approveCallback && approveCallback.call(self, approveParam);
                    return false;
                }
                this.modalSubscriber$.unsubscribe();
                this.modalSubscriber$ = null
              },
              () => {
              },
              () => {
                this.modalSubscriber$ = null;
              });
        } else {
          declineCallback.call(self, declineParam);
          if(declineParam) {
            if(this.currentTab != declineParam.identify) {
              sessionStorage.removeItem('tableState');
            }
            this.currentTab = declineParam.identify;
          }
        }
      });
  }

  handleUnsavedChanges(){
    return this.unsavedChanges$.pipe(map(unsavedChanges => unsavedChanges && !!unsavedChanges.length));
  }

  storeNodeConfigurationData(data: any, isReadOnly: boolean, initial: boolean = false): void {
    if (!isReadOnly) {
      if (initial) {
        this.store$.dispatch(new SetInitialNodeConfigurationData(data));
      } else {
        this.store$.dispatch(new SetUpdatedNodeConfigurationData(data));
      }
    }
  }

  initUnsavedUserActions() {
    this.unsavedChanges$ = this.store$.select(unsavedUserInitiatedActions);
  }
}
